module.exports = __webpack_public_path__ + "static/media/portfolio-image.67290de2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/portfolio-image.png
// module id = 446
// module chunks = 0